import React from "react";
// import moment from "moment";
import "./App.css";
import Spin from "antd/es/spin";
import { Modal, Avatar } from "antd";
import ClearCache from "react-clear-cache";
import { preloadScript } from "opentok-react";
import BlankCache from "./BlankCache";
import Queue from "./components/Queue";
import helper from "./utils/helper";
import FormAuth from "./components/FormAuth";
import RoomVonage from "./RoomVonage";
import Emitter from "./utils/emitter";
import http from "./utils/http";
import { VideoCameraOutlined } from "@ant-design/icons";
import ExpiredPage from "./components/ExpiredPage";

const CryptoJS = window.CryptoJS;

const date = new Date().getTime();
const str = `xmen:${date}`;
const signed = CryptoJS.HmacSHA256(
  str,
  process.env.REACT_APP_ENCRYPT_KEY
).toString(CryptoJS.enc.Hex);
let username = "api";
let password = "api123";

function VideoCall(props) {
  const [queue, setQueue] = React.useState({ inQueue: 0, queuePosition: 0 });
  const [loading, setLoading] = React.useState(false);
  const [waiting, setWaiting] = React.useState(false);
  const [response, setResponse] = React.useState(null);
  const [sessionHelper, setSessionHelper] = React.useState(null);
  const [expired, setExpired] = React.useState(false);
  const [resCode, setResCode] = React.useState(null);
  const [isError, setIsError] = React.useState(false);
  let otSession = React.createRef();

  React.useEffect(() => {
    window.OT.registerScreenSharingExtension(
      "chrome",
      "plocfffmbcclpdifaikiikgplfnepkpo",
      2
    );
    setLoading(true);
    const sid = new URLSearchParams(window.location.search).get("sid");
    if (localStorage.getItem("sid-vonage") || sid) {
      if (parseInt(process.env.REACT_APP_USE_LOCATION) === 1) {
        http.post(
          `${process.env.REACT_APP_API_URL}/${
            process.env.REACT_APP_TENANT
          }/updateLocation?timestamp=${new Date().getMilliseconds()}`,
          {
            sid: sid ? sid : localStorage.getItem("sid-vonage"),
            location: {
              latitude: props.lat,
              longitude: props.long,
            },
          }
        );
      }
      http
        .get(
          `${process.env.REACT_APP_API_URL}/${
            process.env.REACT_APP_TENANT
          }/linkValidation/${sid ? sid : localStorage.getItem("sid-vonage")}`
        )
        .then((res) => {
          setLoading(false);
          setResCode(res.data[0]?.code);
          if (res?.data[0]?.code === 1) {
            http
              .get(
                `${process.env.REACT_APP_API_URL}/${
                  process.env.REACT_APP_TENANT
                }/sessionStatus/${
                  sid ? sid : localStorage.getItem("sid-vonage")
                }?timestamp=${new Date().getMilliseconds()}`
              )
              .then((res) => {
                http
                  .get(
                    `${process.env.REACT_APP_API_URL}/${
                      process.env.REACT_APP_TENANT
                    }/session/${
                      sid ? sid : localStorage.getItem("sid-vonage")
                    }?timestamp=${new Date().getMilliseconds()}`
                  )
                  .then((resp) => {
                    setLoading(false);
                    resp.data.status = res.data;
                    setResponse(resp.data);
                    if (res.data === "waiting" || res.data === "initiated") {
                      onWait(resp.data);
                    } else {
                      setSessionHelper({
                        apiKey: resp.data.room.ot.apiKey,
                        sessionId: resp.data.room.sessionId,
                        token: resp.data.token,
                      });
                    }
                  })
                  .catch(() => {
                    setLoading(false);
                    let qp = new URLSearchParams();
                    qp.set("sid-vonage", "");
                    window.history.replaceState(
                      null,
                      null,
                      "?" + qp.toString()
                    );
                    localStorage.removeItem("sid-vonage");
                  });
              })
              .catch(() => {
                setLoading(false);
                let qp = new URLSearchParams();
                qp.set("sid-vonage", "");
                window.history.replaceState(null, null, "?" + qp.toString());
                localStorage.removeItem("sid-vonage");
                setExpired(true);
              });
          } else {
            setLoading(false);
            let qp = new URLSearchParams();
            qp.set("sid-vonage", "");
            window.history.replaceState(null, null, "?" + qp.toString());
            localStorage.removeItem("sid-vonage");
            if (res.data[0]?.code === 0) {
              setExpired(true);
            } else {
              setIsError(true);
            }
          }
        })
        .catch(() => {
          setLoading(false);
          let qp = new URLSearchParams();
          qp.set("sid-vonage", "");
          window.history.replaceState(null, null, "?" + qp.toString());
          localStorage.removeItem("sid-vonage");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (response) {
      const parameterVidcall = JSON.stringify({
        tenant_id: process.env.REACT_APP_TENANT,
        userid: response?.body?.email,
        type: "customer",
        room: response?.room?.uniqueName,
      });

      const paramsVidcall = helper.encrypt(parameterVidcall);

      let socketVidcall = window.io(process.env.REACT_APP_API_URL, {
        path: `/${process.env.REACT_APP_TENANT}/socket.io`,
        query: { data: paramsVidcall },
        transports: ["websocket"],
      });

      if (response?.status !== "handling") {
        checkQueue(response?.room?.uniqueName);
      }
      const intervalTime = parseInt(process.env.REACT_APP_INTERVAL);

      const intervalQueue = setInterval(() => {
        if (response?.status !== "handling") {
          checkQueue(response?.room?.uniqueName);
        } else {
          clearInterval(intervalQueue);
        }
      }, intervalTime);

      socketVidcall.on("accept_video_call", (data) => {
        setLoading(false);
        clearInterval(intervalQueue);
        setWaiting(false);
        setSessionHelper({
          apiKey: response.room.ot.apiKey,
          sessionId: response.room.sessionId,
          token: response.token,
        });
      });

      socketVidcall.on("end_video_call", (data) => {
        endCall();
      });

      socketVidcall.on("newChatVideoCall", (data) => {
        Emitter.emit("MESSAGE_SET", JSON.parse(helper.decrypt(data)));
      });
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const onWait = async (resp) => {
    setWaiting(true);
  };

  const endCall = () => {
    otSession?.current?.sessionHelper.disconnect();
    setSessionHelper(null);
    localStorage.removeItem("sid-vonage");
    window.location.href = process.env.REACT_APP_REDIRECT_URL;
    sessionStorage.removeItem("isQueue");
  };
  const checkQueue = (sid) => {
    http
      .get(
        `${process.env.REACT_APP_API_URL}/${
          process.env.REACT_APP_TENANT
        }/queuePosition/${sid}?timestamp=${new Date().getMilliseconds()}`
      )
      .then((res) => {
        const checkQueue = sessionStorage.getItem("isQueue");
        const data = JSON.parse(checkQueue);
        if (checkQueue) {
          sessionStorage.setItem(
            "isQueue",
            JSON.stringify({
              queue: response.data,
              data: data.data,
            })
          );
        }
        setQueue(res.data);
      });
  };

  React.useEffect(() => {
    const tidyUp = (event) => {
      if (event.persisted) {
        return;
      }
    };
    window.addEventListener("pagehide", tidyUp);
    window.addEventListener("beforeunload", tidyUp);
    return () => {
      window.removeEventListener("pagehide", tidyUp);
      window.removeEventListener("beforeunload", tidyUp);
    };
  }, []);

  return (
    <Spin spinning={loading} tip="Sedang memproses..." className="h-full">
      {waiting ? (
        <Queue
          setWaiting={setWaiting}
          queue={queue}
          handleLogout={endCall}
          response={response}
          wording="Anda telah terhubung dengan Petugas"
          platform={process.env.REACT_APP_PLATFORM}
          resCode={resCode}
        />
      ) : sessionHelper && !waiting ? (
        <RoomVonage
          hangup={endCall}
          session={sessionHelper}
          response={response}
        />
      ) : isError ? (
        <Queue
          response={response}
          resCode={resCode}
          wording="Silakan Menunggu"
          platform={process.env.REACT_APP_PLATFORM}
        />
      ) : !expired ? (
        <FormAuth
          {...props}
          setLoading={setLoading}
          setResponse={setResponse}
          onWait={onWait}
          queue={queue}
          platform={process.env.REACT_APP_PLATFORM}
        />
      ) : (
        <ExpiredPage />
      )}
    </Spin>
  );
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error_name: "",
      error_description: "",
      error_line: "",
      hasError: false,
      opsHour: null,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error_name: error.message,
      error_description: errorInfo.componentStack,
      error_line: errorInfo.componentStack.split(":")[0],
    });
  }

  componentDidMount() {
    this.loadOpsHour();
  }

  loadOpsHour = () => {
    http
      .get(
        `${process.env.REACT_APP_API_OMNIX_URL}/${process.env.REACT_APP_TENANT}/external/checkJamOpsWithMessage`,
        {
          auth: {
            username: username,
            password: password,
          },
        },
        {
          headers: {
            "x-encrypt": signed,
            "x-time": date,
            "x-tenant": process.env.REACT_APP_TENANT,
          },
        }
      )
      .then((res) => {
        if (res) {
          this.setState({ opsHour: res.data });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <ClearCache>
        {({ isLatestVersion, emptyCacheStorage }) =>
          !isLatestVersion ? (
            <BlankCache emptyCacheStorage={emptyCacheStorage} />
          ) : // ) : (
          this.state.opsHour?.status === true ? (
            <VideoCall {...this.props} />
          ) : (
            <Modal
              title=""
              open={true}
              footer={null}
              closable={false}
              width={540}
            >
              <div style={{ textAlign: "center" }}>
                <Avatar
                  size={64}
                  icon={<VideoCameraOutlined style={{ color: "#fff" }} />}
                  style={{ background: "red" }}
                />
                {/* <p style={{
                  lineHeight: 1.8
                }}
                  dangerouslySetInnerHTML={{
                    __html: this.state.opsHour?.messsage,
                  }}
                /> */}
                <p
                  style={{
                    lineHeight: 1.8,
                    marginBottom: "5px",
                    fontSize: "12px",
                  }}
                >
                  Mohon maaf, saat ini Bapak/Ibu berada di luar jam operasional
                  konsultasi OSS. <br />
                  Jadwal Konsultasi OSS: Senin-Jumat (hari libur nasional) pukul
                  08.00-16.00 WIB. <br />
                  <br />
                  Dapatkan panduan layanan OSS di{" "}
                  <a
                    href="https://oss.go.id/panduan"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://oss.go.id/panduan
                  </a>
                  <br />
                  <br />
                  Salam,
                  <br />
                  Kementerian Investasi dan Hilirisasi/BKPM
                </p>
              </div>
            </Modal>
          )
        }
      </ClearCache>
    );
  }
}

export default preloadScript(App);
